import CreateCourseBasicDetailsBlock from './CreateCourseBasicDetailsBlock';
import { CreateCourseBasicDetailsBlockProps, CreateCourseBasicDetailsBlockValueProps } from './types';

export type { CreateCourseBasicDetailsBlockProps, CreateCourseBasicDetailsBlockValueProps };
export default CreateCourseBasicDetailsBlock;
